import React from "react";
import SvgIcon from "../SvgIcon";

export function LinkedIn({ color, size }) {
    return (
      <SvgIcon color={color} fontSize={size} viewBox="0 0 20 19">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.261 15.827h-2.504v-4.382c0-1.202-.53-1.873-1.482-1.873-1.035 0-1.649.699-1.649 1.873v4.382H8.122v-8.14h2.504v.916s.786-1.379 2.557-1.379 3.078 1.081 3.078 3.317zM5.268 6.387A1.534 1.534 0 0 1 3.74 4.844a1.535 1.535 0 0 1 1.53-1.54 1.534 1.534 0 0 1 1.527 1.54 1.534 1.534 0 0 1-1.528 1.541m-1.529 9.44h3.13v-8.14H3.74z" fill="#446475"/>
    </SvgIcon>
  );
}